import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ContactListComponent } from './components/contact-list/contact-list.component';
import { AvatarModule } from '@epicuro-next/ataraxia/avatar';
import { BusinessContactsComponent } from './components/business-contacts/business-contacts.component';
import { SearchableContactsListComponent } from './components/searchable-contacts-list/searchable-contacts-list.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AccordionModule } from '@epicuro-next/ataraxia/accordion';
import { IconsModule } from '@epicuro-next/ataraxia/icons';

@NgModule({
  imports: [
    AccordionModule,
    AvatarModule,
    CommonModule,
    FormsModule,
    IconsModule,
    ReactiveFormsModule,
  ],
  declarations: [
    BusinessContactsComponent,
    ContactListComponent,
    SearchableContactsListComponent,
  ],
  exports: [
    BusinessContactsComponent,
    ContactListComponent,
    SearchableContactsListComponent,
  ],
})
export class AtaraxiaContactsModule {}
